"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeText = void 0;
const getNodeText = (node) => {
    if (node == null)
        return '';
    switch (typeof node) {
        case 'string':
        case 'number':
            return node.toString();
        case 'boolean':
            return '';
        case 'object': {
            if (node instanceof Array)
                return node.map(exports.getNodeText).join('');
            if ('props' in node)
                return (0, exports.getNodeText)(node.props.children);
        } // eslint-ignore-line no-fallthrough
        default:
            console.warn('Unresolved `node` of type:', typeof node, node);
            return '';
    }
};
exports.getNodeText = getNodeText;
